export default "{\n    \"viewLabel\": \"Ver\",\n    \"downloadLabel\": \"Descargar\"\n}\n"